import { Action } from 'common/interfaces/root';
import { publishersSettingsActionTypes as T } from '../actions';

const initState: PublishersSettingsModule.PublisherSettingsStore = {
  loading: true,
  error: null,
  data: null,
};

export default (
  state: PublishersSettingsModule.PublisherSettingsStore = initState,
  { type, payload }: Action
): PublishersSettingsModule.PublisherSettingsStore => {
  switch (type) {
    case T.GET_MAIN_PUBLISHER_INFO:
      return { ...state, loading: true };

    case T.GET_MAIN_PUBLISHER_INFO_SUCCESS:
      return { ...state, loading: false, data: payload.data };

    case T.GET_MAIN_PUBLISHER_INFO_ERROR:
      return { ...state, loading: false, error: payload };

    default:
      return state;
  }
};
